import Vue from 'vue'
import App from './App.vue'
import i18n from './common/plugins/vue-i18n';
import routes from './config/AppRoutes'
import store from './components/store/index';
import moment from 'moment'
// plugins
import VueRouter from 'vue-router';
import VueBootstrap from 'bootstrap-vue'
import VueCustomScrollbar from 'vue-custom-scrollbar'
import VueColorPicker from '@caohenghu/vue-colorpicker'
import * as VueApexCharts from 'vue-apexcharts'
import { BToast  } from 'bootstrap-vue'
import VueDatetimeJs from 'vue-datetime-js';
import axios from 'axios';
import Multiselect from 'vue-multiselect'
import Loading from 'vue-loading-overlay';    //loading
import VueTimepicker from 'vue2-timepicker';
// VueStudio SCSS
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import '@fullcalendar/core/main.css'
import '@fullcalendar/daygrid/main.css'
import '@fullcalendar/timegrid/main.css'
import '@fullcalendar/list/main.css'
import '@fullcalendar/bootstrap/main.css'
import './scss/styles.scss'
import './assets/css/main.css'
import './assets/css/responsive.css'
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue2-timepicker/dist/VueTimepicker.css';
import log from "echarts/src/scale/Log";
//全局变量
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};
Vue.prototype.GLOBAL=App;
App.mpType = 'app';
Vue.prototype._i18n = i18n;
Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;//全局注册，使用方法为:this.$axios

Vue.use(Loading, {
    color:'#007bff',
    loader:'spinner',
    width: 40,
    height: 40,
    backgroundColor: '#ffffff',
    opacity: 0.7,
    zIndex: 999999,
});
Vue.use(VueRouter);
Vue.use(VueBootstrap);
Vue.prototype.$axios = axios;
Vue.component('b-toast', BToast);
Vue.component('date-picker', VueDatetimeJs);
Vue.component('vue-timepicker', VueTimepicker);
Vue.component('multiselect', Multiselect);
Vue.component('vue-custom-scrollbar', VueCustomScrollbar);
Vue.component('apexchart', VueApexCharts);
Vue.component('vue-color-picker', VueColorPicker);

//axios拦截器 定义一个请求拦截器
axios.interceptors.request.use(
    config =>{
        // console.log("请求拦截器", config)
        if(localStorage.getItem('isToken')){
            config.headers['x-auth-token']=localStorage.getItem('isToken');
            // config.headers['uid']=localStorage.getItem('uid');
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
//定义一个响应拦截器
axios.interceptors.response.use(
    response =>{
        // console.log("响应拦截器",response)
        // 只保存接口返回的 token。跳转交给登录页处理，避免 token 还没写入就进首页被守卫打回。
        if (response.data && response.data.token) {
            localStorage.setItem('token', response.data.token);
        }

        // if(response.data.success === "true"){
        //     router.push({path: '/login'});
        //     localStorage.removeItem('token')
        //     localStorage.removeItem('isToken')
        // }
        // if (response.data.token !== null){
        //     router.push({path: '/home'});
        // }


        // 权限不足（过期）401重新跳转登录重新登录
        // if(response.data.error==='401'){
        //     router.push({path: '/login'});
        // }
        return response;
    },
    error => {
        // 权限不足（过期）401重新跳转登录重新登录
        // if(error.response){
        //     if(error.response.status === 401){
        //         router.push({path: '/login'});
        //     }
        // }
        return Promise.reject(error);
    }
);

Vue.config.productionTip = false;
const router = new VueRouter({
	routes,
    base: process.env.BASE_URL,
});

router.beforeEach((to, from, next) => {
    if (!to.meta.requireAuth) {
        next();
        return;
    }
    const isToken = localStorage.getItem('token');
    if (isToken) {
        next();
        return;
    }
    next({
        path: '/login',
    });
})

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app');


Vue.filter('MoneyFormat', function(money) {
    if (money && money != null) {
        money = String(money);
        var left = money.split('.')[0], right = money.split('.')[1];
        right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00';
        var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
        return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right;
    } else if (money === 0) { // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
        return '0.00';
    } else {
        return '';
    }
});
